export const constants = {
    Success_Status: "Succeeded",
    Failed_Status: "Failed",
    Loading_Status: "Loading...",
    Success_Class: "success",
    Failed_Class: "failure",
    InProcess_Class: "inProcess"
}